<app-confirmation-dialog [props]="props">
  <div id="partner-modal-content" class="body-container">
    <div id="partner-modal-lbl-doc" class="partner-modal-subtitle">
      <span i18n="@@partnerModalDocLabel">Documento:</span>
      {{ formattedRegistryDocument }}
    </div>

    <app-generic-table
      [id]="'partner-modal-table'"
      [style]="{ 'min-height': '150px' }"
      [isLoading]="isLoading()"
      [config]="tableConfig"
      [data]="rows()"
      [showPagination]="false"
    >
      <ng-template appTableCell="label" let-row>
        <app-truncated-text [text]="row.label || '-'" [maxLines]="2" />
      </ng-template>

      <ng-template appTableCell="value" let-row>
        <app-truncated-text [text]="row.value || '-'" [maxLines]="2" />
      </ng-template>
    </app-generic-table>
  </div>
</app-confirmation-dialog>
